import React, { useEffect, useRef, useState } from 'react';

const Hero = () => {
  const typedRef = useRef(false);
  const [showVideoModal, setShowVideoModal] = useState(false);

  // Add typewriter effect to gradient text
  useEffect(() => {
    if (typedRef.current) return; // Prevent multiple executions
    typedRef.current = true;

    const text = 'With Innovation';
    const element = document.querySelector('.gradient-text');
    if (element) {
      element.textContent = '';
      let index = 0;
      
      const typeWriter = () => {
        if (index < text.length) {
          element.textContent += text.charAt(index);
          index++;
          setTimeout(typeWriter, 100);
        }
      };
      
      setTimeout(typeWriter, 500);
    }
  }, []);

  // ...existing code...

  return (
    <section className="hero" id="home">
      <div className="hero-content" style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', minHeight: '80vh', textAlign: 'center', gap: '2.5rem' }}>
        <div className="hero-text fade-in" style={{ maxWidth: 700 }}>
          <h1 style={{ fontSize: 'clamp(2.5rem, 6vw, 4.5rem)', fontWeight: 900, marginBottom: '1.2rem', lineHeight: 1.1 }}>
            Building The Future <span className="gradient-text">With Innovation</span>
          </h1>
          <p style={{ fontSize: '1.35rem', color: 'rgba(255,255,255,0.82)', marginBottom: '2.5rem', lineHeight: 1.7 }}>
            Transform your business with cutting-edge glassmorphic design and powerful software solutions.
          </p>
          <div className="cta-buttons" style={{ justifyContent: 'center', gap: '1.5rem', display: 'flex', flexWrap: 'wrap' }}>
            <a href="#contact" className="glass-btn glass-btn-primary" style={{ minWidth: 180 }}><span>Start Project</span> →</a>
            <a href="#services" className="glass-btn glass-btn-secondary" style={{ minWidth: 180 }}><span>Explore Services</span></a>
          </div>
        </div>
      </div>

      {/* Video Modal */}
      {showVideoModal && (
        <div className="video-modal-overlay" onClick={() => setShowVideoModal(false)}>
          <div className="video-modal-content" onClick={(e) => e.stopPropagation()}>
            <button className="video-modal-close" onClick={() => setShowVideoModal(false)}>✕</button>
            <iframe 
              width="100%" 
              height="600" 
              src="https://www.youtube.com/embed/dQw4w9WgXcQ?autoplay=1" 
              title="Zentak Solutions Demo" 
              frameBorder="0" 
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" 
              allowFullScreen
            />
          </div>
        </div>
      )}
    </section>
  );
};

export default Hero;